import { render, staticRenderFns } from "./AttributeItem.vue?vue&type=template&id=63ef05f8"
import script from "./AttributeItem.vue?vue&type=script&lang=js"
export * from "./AttributeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports